interface Props {
  resetTags(): void;
}

export const RemoveFiltersButton = ({ resetTags }: Props): JSX.Element => {
  return (
    <button
      aria-label="Rensa filter"
      title="Ta bort alla filter"
      className="top-1/2 right-2 absolute self-center bg-grey50 p-2 rounded-full focus:outline-none translate-y-1/2- button"
      type="button"
      onClick={() => {
        resetTags();
      }}
    >
      <img
        src={'/Images/Icons/close.svg'}
        alt="Ta bort filter ikon"
        width={21}
        height={21}
        loading="lazy"
      />
    </button>
  );
};
